import React from 'react';

export default function PaymentsMadeGeneral({ setError, error, setForm, form }) {
	return <div>Development In Progress</div>;
}
